import { useEffect } from "react";
import React from "react";

import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { BugReport, Login, Logout } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { blueGrey } from "@mui/material/colors";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { getCurrentUser, logout } from "../../../services/authService";

const theme = createTheme({
  palette: {
    primary: { main: "#FE6B8B" },
    secondary: { main: "#FF8E53" },
    background: { default: "#ffffff" },
    button: { main: blueGrey[100], dark: blueGrey[300] },
  },
});

const Layout = ({ children }) => {
  const { t, i18n } = useTranslation(["home_page"]);
  const location = useLocation();
  const navigate = useNavigate();
  const user = getCurrentUser();

  useEffect(() => {
    ReactGA.initialize("G-RJ2C336DGR");
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container
        maxWidth="lg"
        sx={{
          paddingY: 2,
          minHeight: "100dvh",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="stretch">
          <img
            src={"/logo_white.svg"}
            style={{ height: "60px", width: "110px", objectFit: "cover" }}
            alt="Logo"
          />
          <Stack gap={1} alignItems="flex-end">
            <Stack direction="row" gap={1}>
              <IconButton
                onClick={() => handleLanguageChange("en")}
                sx={{ padding: 0 }}
              >
                <img src="/flags/en.png" alt="English" width={24} height={24} />
              </IconButton>
              <IconButton
                onClick={() => handleLanguageChange("ja")}
                sx={{ padding: 0 }}
              >
                <img src="/flags/jp.png" alt="日本語" width={24} height={24} />
              </IconButton>
            </Stack>
            <Link
              href="https://x.com/ptcgdatabase"
              target="_blank" // 新しいタブで開く
              rel="noopener noreferrer" // セキュリティ対策
              color="inherit"
              underline="none"
              sx={{
                borderBottom: "1px solid grey",
                display: "flex",
              }}
            >
              <BugReport fontSize="small" />
              <Typography variant="caption">{t("report_bug")}</Typography>
            </Link>
            {user ? (
              <Button
                color="inherit"
                startIcon={<Logout />}
                onClick={() => {
                  logout();
                  navigate("");
                }}
                sx={{ paddingRight: 0 }}
                size="small"
              >
                <Typography variant="caption">{t("logout")}</Typography>
              </Button>
            ) : (
              <Button
                color="inherit"
                startIcon={<Login />}
                onClick={() => {
                  navigate("/login");
                }}
                sx={{ paddingRight: 0 }}
                size="small"
              >
                <Typography variant="caption">{t("login")}</Typography>
              </Button>
            )}
          </Stack>
        </Box>
        <Box flexGrow={1} marginBottom={6}>
          {children}
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default Layout;
